import * as React from 'react';

import {Button} from 'shells/button/button';
// @ts-expect-error - imported from .js/.jsx file
import {ExternalLinkIcon} from 'shells/icon/svg/external-link-icon';
import {GlossaryIcon} from 'shells/icon/svg/glossary-icon';
import {Illustration} from 'shells/illustrations/illustration';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import styles from './add-on-card.module.css';

interface Props {
    title: string;
    description: string;
    illustrationSrc: string;
    href?: string;
    onOpenModal?: () => void;
}

export function AddOnCard(props: Props) {
    const getLearnMore = () => {
        if (props.onOpenModal) {
            return (
                <Button
                    variant='text-primary'
                    onClick={props.onOpenModal}
                    size='small'
                    noPadding={true}
                >
                    <Stack spacing={6} isHorizontal={true} alignItems='center'>
                        <GlossaryIcon size={12} alignCenter={true} />
                        <div>Learn more</div>
                    </Stack>
                </Button>
            );
        }
        if (props.href) {
            return (
                <Link variant='primary' size='small' newTab={true} href={props.href}>
                    <Stack spacing={6} isHorizontal={true} alignItems='center'>
                        <ExternalLinkIcon size={12} alignCenter={true} />
                        <div>Learn more</div>
                    </Stack>
                </Link>
            );
        }
        return null;
    };

    return (
        <Stack spacing={16} isHorizontal={true}>
            <div className={styles['illustration-container']}>
                <Illustration src={props.illustrationSrc} />
            </div>
            <Stack spacing={4}>
                <Body isBold={true}>{props.title}</Body>
                <Body size='small'>{props.description}</Body>
                {getLearnMore()}
            </Stack>
        </Stack>
    );
}
